import {
    memo,
    MutableRefObject,
    RefObject,
    useCallback,
    useRef,
    useState,
} from 'react';
import cn from 'classnames';
import { OBJECT_TYPE } from 'src/constants';
import { IContent } from 'src/interface';
import { useOutsideClick } from 'src/hooks';
import { Button, Element, Icon } from 'src/components';
import Menu from 'src/components/menu';
import ShareButton from 'src/modules/shared/components/buttons/ShareButton';
import ChangeSizeButton from 'src/modules/shared/components/buttons/ChangeSizeButton';
import BookmarkButton from 'src/modules/shared/components/buttons/BookmarkButton';
import FollowButton from 'src/modules/shared/components/buttons/FollowButton';
import ReportButton from '../../ContentSocial/ReportButton';
import styles from './style.module.scss';

interface IProps {
    content: IContent;
    classNames?: string;
}

export function ContentMoreAction({ content, classNames }: IProps) {
    const { publisher, url, shareUrl, title, contentId } = content;
    const [isExpand, setIsExpand] = useState<boolean>(false);
    const btnRef: MutableRefObject<any> = useRef<RefObject<any>>(null);
    const menuRef: MutableRefObject<any> = useRef<RefObject<any>>(null);

    const handleClick = useCallback(
        (evt: React.MouseEvent) => {
            setIsExpand(!isExpand);
        },
        [isExpand]
    );

    useOutsideClick([btnRef, menuRef], (isExpand) => {
        if (!isExpand) {
            setIsExpand(false);
        }
    });

    return (
        <Element className={cn(styles['content-more-action'], classNames)}>
            <ShareButton
                className={styles['action-share']}
                url={url}
                shareUrl={shareUrl}
                title={title}
            />
            <Button
                onClick={handleClick}
                className={cn(
                    'action-more',
                    'flex items-center justify-center',
                    'w-[42px] h-[42px]',
                    'bg-white',
                    'rounded-full',
                    'border border-solid border-[#e9ecef]'
                )}
                domRef={btnRef}
                title="Khác"
            >
                <Icon className='text-[2rem] text-[#adb5bd]' icon="ellipsis-h-alt"></Icon>
            </Button>
            <Element
                className={cn(styles['more-action-dropdown'], {
                    [styles[`is-expand`]]: isExpand,
                })}
                domRef={menuRef}
            >
                <Menu.List>
                    <Menu.List.Item>
                        <ChangeSizeButton
                            contentId={contentId}
                            className={styles['btn-social']}
                        />
                    </Menu.List.Item>
                    <Menu.List.Item>
                        <BookmarkButton
                            contentId={contentId}
                            className={styles['btn-social']}
                        />
                    </Menu.List.Item>
                    <Menu.List.Item>
                        {publisher && (
                            <FollowButton
                                title={`Theo dõi ${publisher.shortName}`}
                                objectType={OBJECT_TYPE.PUBLISHER}
                                objectId={publisher.id}
                            />
                        )}
                    </Menu.List.Item>
                    <Menu.List.Item>
                        <ShareButton
                            shareUrl={shareUrl}
                            url={url}
                            title={title}
                        />
                    </Menu.List.Item>
                    <Menu.List.Item>
                        <ReportButton contentId={contentId} />
                    </Menu.List.Item>
                </Menu.List>
            </Element>
        </Element>
    );
}

export default memo(ContentMoreAction);
